import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { ROOF_TYPES } from '../../data/site';
import { Reveal } from '../common/Reveal';

export const RoofTypes = ({ title = 'Professional Roof Replacement To Save Money!' }) => (
  <section className="py-24 bg-secondary" data-testid="roof-types-section">
    <div className="max-w-[1320px] mx-auto px-4 lg:px-8">
      <Reveal className="text-center max-w-2xl mx-auto">
        <span className="eyebrow justify-center">Roof Replacement</span>
        <h2 className="section-title mt-4" data-testid="roof-types-title">{title}</h2>
        <p className="mt-5 text-lg text-muted-foreground">
          Choose from flat, asphalt shingle, slate, or metal roofing for the perfect blend of style and durability.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-7 mt-14">
        {ROOF_TYPES.map((r, i) => (
          <Reveal key={r.title} delay={(i % 2) * 0.1}>
            <div className="group h-full rounded-2xl bg-card border border-border overflow-hidden card-lift" data-testid={`roof-type-${r.title.toLowerCase().replace(/\s+/g, '-')}`}>
              <div className="overflow-hidden">
                <img src={r.image} alt={r.title} className="w-full h-[230px] md:h-[270px] object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />
              </div>
              <div className="p-7">
                <h3 className="font-heading font-bold text-xl capitalize">{r.title.toLowerCase()}</h3>
                <p className="mt-2.5 text-muted-foreground">{r.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal className="text-center mt-14">
        <Link to="/free-estimate" className="btn-cta" data-testid="roof-types-cta">
          Request a Free In-House Estimate <ArrowRight className="w-4 h-4" />
        </Link>
      </Reveal>
    </div>
  </section>
);
